import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useFelaEnhanced } from '@ackee/fela';

import { Modal, ModalType, Text, TextTypes } from 'modules/ui';

import * as felaRules from './BookingModal.rules';

export interface BookingModalProps {
    open: boolean;
    setOpen: (open: boolean) => void;
}

export const BookingModal = ({ open, setOpen }: BookingModalProps) => {
    const { styles } = useFelaEnhanced(felaRules);
    const { formatMessage } = useIntl();

    return (
        <Modal
            open={open}
            type={ModalType.small}
            onOpenChange={open => setOpen(open)}
            title={formatMessage({ id: 'bookCallModal.title' })}
        >
            <div className={styles.modalContainer}>
                <div className={styles.modalTextContainer}>
                    {/* @ts-expect-error */}
                    <Text type={TextTypes.LARGE}>
                        <FormattedMessage id="bookCallModal.text" />
                    </Text>
                </div>
                <div className={styles.iframeContainer}>
                    <iframe
                        title={formatMessage({ id: 'bookCallSection.cta' })}
                        className={styles.iframe}
                        src={formatMessage({ id: 'bookCallModal.iframeUrl' })}
                    ></iframe>
                </div>
            </div>
        </Modal>
    );
};
